import React from "react";
import purpleSection1 from "../../assets/home/purpleSection/purpleSection1.webp";
import purpleSection2 from "../../assets/home/purpleSection/Senior Transport.jpg";
import purpleSection5 from "../../assets/home/purpleSection/picture2.jpg";
import purpleSection6 from "../../assets/home/purpleSection/Seniors Moving.jpg";
import black1 from "../../assets/home/purpleSection/Senior Exercise.jpg";
import black2 from "../../assets/home/purpleSection/picture1.png";
import { Link } from "react-router-dom";

// ServiceBox component for consistent styling
const ServiceBox = ({ image, title, alt }) => {
  return (
    <div className="flex flex-col h-full">
      <div className="relative aspect-[1.1/1] w-full overflow-hidden rounded-t-lg border-8">
        <img src={image} alt={alt} className="h-full w-full object-cover" />
      </div>
      <div className="bg-purple-700 p-3 rounded-b-lg border-t-2 border-purple-600">
        {" "}
        {/* Reduced padding from p-4 to p-3 */}
        <p className="text-black font-semibold text-center text-lg relative bottom-12 z-10 bg-gray-300 h-10">
          {" "}
          {/* Adjusted bottom spacing from 14 to 12 */}
          {title}
        </p>
      </div>
    </div>
  );
};

export function PurpleSection() {
  return (
    <div className="bg-purple-700 w-full">
      <div className="container mx-auto px-4 py-12">
        {" "}
        {/* Reduced py-16 to py-12 */}
        <div className="text-center mb-10">
          {" "}
          {/* Reduced mb-12 to mb-8 */}
          <h2 className="text-white text-3xl font-semibold max-w-4xl mx-auto">
            SilverTLC.Com offers access to wrap around services, appointment
            setting and bill payment through one dashboard:
          </h2>
        </div>
        <div className="max-w-7xl mx-auto">
          {/* First row - 3 boxes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            {" "}
            {/* Reduced gap and margin from 6 to 4 */}
            <ServiceBox
              image={purpleSection1}
              title="Affordable Housing"
              alt="housing"
            />
            <ServiceBox
              image={black2}
              title="Skilled Nursing And Home Health Care"
              alt="Skilled-Nursing"
            />
            <ServiceBox
              image={purpleSection2}
              title="Transportation"
              alt="transportation"
            />
          </div>

          {/* Second row - 3 boxes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {" "}
            {/* Reduced gap from 6 to 4 */}
            <ServiceBox
              image={purpleSection5}
              title="Medication and Food Delivery"
              alt="Grocery"
            />
            <ServiceBox image={purpleSection6} title="Moving" alt="moving" />
            <ServiceBox
              image={black1}
              title="Adult Day Care And Fitness Centers"
              alt="Adult-day"
            />
          </div>

          {/* Bottom text */}
          <div className="text-center mt-[-2rem]">
            {" "}
            {/* Reduced mt-12 to mt-8 */}
            <p className="text-white text-xl font-semibold">
              To get access to these services, please{" "}
              <Link to="/register" className="underline hover:text-purple-200">
                register
              </Link>{" "}
              or{" "}
              <Link to="/login" className="underline hover:text-purple-200">
                log-in
              </Link>{" "}
              here.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
